var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "progress-group" }, [
      _c("div", { staticClass: "progress-group-header" }, [
        _c("i", { staticClass: "fa fa-shield fa-fw progress-group-icon" }),
        _c("span", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("message.security_risk"))),
        ]),
        _c("span", { staticClass: "ml-auto font-weight-bold" }, [
          _vm._v(_vm._s(_vm.securityCount) + "\n        "),
          _c("span", { staticClass: "text-muted small" }, [
            _vm._v("(" + _vm._s(_vm.securityPercent) + "%)"),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "progress-group-bars" },
        [
          _c("b-progress", {
            staticClass: "progress-xs",
            attrs: {
              height: "{}",
              value: _vm.securityPercent,
              variant: "violation-type",
            },
          }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "progress-group" }, [
      _c("div", { staticClass: "progress-group-header" }, [
        _c("i", {
          staticClass: "fa fa-balance-scale fa-fw progress-group-icon",
        }),
        _c("span", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("message.license_risk"))),
        ]),
        _c("span", { staticClass: "ml-auto font-weight-bold" }, [
          _vm._v(_vm._s(_vm.licenseCount) + "\n        "),
          _c("span", { staticClass: "text-muted small" }, [
            _vm._v("(" + _vm._s(_vm.licensePercent) + "%)"),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "progress-group-bars" },
        [
          _c("b-progress", {
            staticClass: "progress-xs",
            attrs: {
              height: "{}",
              value: _vm.licensePercent,
              variant: "violation-type",
            },
          }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "progress-group" }, [
      _c("div", { staticClass: "progress-group-header" }, [
        _c("i", { staticClass: "icon-layers fa-fw progress-group-icon" }),
        _c("span", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("message.operational_risk"))),
        ]),
        _c("span", { staticClass: "ml-auto font-weight-bold" }, [
          _vm._v(_vm._s(_vm.operationalCount) + "\n        "),
          _c("span", { staticClass: "text-muted small" }, [
            _vm._v("(" + _vm._s(_vm.operationalPercent) + "%)"),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "progress-group-bars" },
        [
          _c("b-progress", {
            staticClass: "progress-xs",
            attrs: {
              height: "{}",
              value: _vm.operationalPercent,
              variant: "violation-type",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }